import { PageHeader, Popconfirm, Select, Space, message,Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SelectItem, TableItem } from "../../../Components/Items";
import SelectMarcasItem from "../../../Components/SelectMarcasItem";
import SelectProveedoresItem from "../../../Components/SelectProveedoresItem";
import AgregarControlInventario from "./AgregarControlInventario/AgregarControlInventario";
import { DeleteOutlined, EditOutlined, FileAddOutlined, ImportOutlined } from "@ant-design/icons";
import EditarControlInventario from "./EditarControlInventario/EditarControlInventario";

const { Option } = Select;

class ControlInventario extends Component {
  state = {
    loading: false,
    objetoProyectos: [],
    todasProyectos: [],
    todasControlInventario: [],
    proyecto: undefined,
    proyectoId: undefined,
    marcaFiltro: undefined,
    proveedorFiltro: undefined,
    controlesSeleccionados: [],
    modalAgregarControl: false,
    modalEditarControl: false,
    modalEditarControlId: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "controlInventario/selectControlInventario",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasControlInventario: res.data.map((value) => {
              return {
                ...value,
                codigo: value.insumo.codigo,
                descripcion: value.insumo.descripcion,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
        }
        this.setState({ loading: false });
      });
  }

  onChangeProyecto(value) {
    if (value === 0) {
      this.setState({ loading: true, proyecto: undefined, proyectoId: 0 });
      const body = { empresaId: this.props.empresaId };
      if (this.state.proveedorFiltro) body.proveedorId = this.state.proveedorFiltro;
      axios
        .post(
          "controlInventario/selectControlInventario",
          body,
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            this.setState({ todasControlInventario: [] })
          } else {
            this.setState({
              todasControlInventario: res.data
            });
          }
          this.setState({ loading: false });
        });
    } else {
      const proyecto = this.state.todasProyectos.find(valueState => valueState._id.toString() === value.toString())
      this.setState({ loading: true, proyecto: proyecto.nombre, proyectoId: proyecto._id });
      const body = { empresaId: this.props.empresaId, proyectoId: value };
      if (this.state.proveedorFiltro) body.proveedorId = this.state.proveedorFiltro;
      axios
        .post(
          "controlInventario/selectControlInventario",
          body,
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            this.setState({ todasControlInventario: [] })
          } else {
            this.setState({
              todasControlInventario: res.data
            });
          }
          this.setState({ loading: false });
        });

      }
  }
  onChangeProveedor(value) {
    this.setState({ loading: true, proveedorFiltro: value });
    const body = { empresaId: this.props.empresaId };
    if (this.state.proyectoId) body.proyectoId = this.state.proyectoId;
    if (value) body.proveedorId = value;
    axios
      .post(
        "controlInventario/selectControlInventario",
        body,
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ todasControlInventario: [] })
        } else {
          this.setState({
            todasControlInventario: res.data
          });
        }
        this.setState({ loading: false });
      });
  }
  abrirAgregarControlInventario() {
    this.setState({
      modalAgregarControl: true
    })
  }
  cerrarAgregarControlInventario() {
    this.setState({
      modalAgregarControl: false,
      proyectoId: 0,
      loading: true
    })
    this.onChangeProyecto(0)
  }
  abrirEditarControlInventario(id) {
    this.setState({
      modalEditarControl: true,
      modalEditarControlId: id
    })
  }
  cerrarEditarControlInventario() {
    this.setState({
      modalEditarControl: false,
      modalEditarControlId: undefined,
      proyectoId: 0,
      loading: true
    })
    this.onChangeProyecto(0)
  }
  eliminarControlInventario(value) {
    axios
      .post(
        "controlInventario/eliminarControl",
        { controlId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Control eliminado");
        } else {
          message.error("Sucedio un error y no se pudo eliminar");
        }
        this.onChangeProyecto(0);
      });
  }

  abrirReq(record = null) {
    let itemsParaRequisicion = [];
    let proyectoId = this.state.proyectoId;

    if (!proyectoId) {
      //Si no tiene proyecto selecciona el primero de la lista
      if (this.state.todasProyectos.length > 0) {
        proyectoId = this.state.todasProyectos[0]._id;
      } else {
        return message.warning("No hay proyectos disponibles para generar requisición.");
      }
    }

    // Caso de un solo insumo
    if (record) {
      const cantidadFaltante = record.max - record.cantidadActual;
      if (cantidadFaltante <= 0) {
        return message.warning("El stock ya está al máximo o lo supera.");
      }
      itemsParaRequisicion.push({
        insumoId: record.insumo._id, 
        cantidad: cantidadFaltante,
        tempData: { 
          codigo: record.codigo, 
          descripcion: record.descripcion, 
          unidad: record.unidad 
        }
      });
    } 
    else {
      const { controlesSeleccionados } = this.state;
      const baseInsumos = controlesSeleccionados.length
        ? this.state.todasControlInventario.filter(item => controlesSeleccionados.includes(item._id))
        : this.state.todasControlInventario;

      const insumosFaltantes = baseInsumos.filter(item => {
        return (item.max - item.cantidadActual) > 0;
      });

      if (insumosFaltantes.length === 0) {
        return message.info(
          controlesSeleccionados.length
            ? "Los insumos seleccionados ya están al máximo."
            : "Todos los insumos de este proyecto están completos."
        );
      }

      itemsParaRequisicion = insumosFaltantes.map(item => ({
        insumoId: item.insumo._id,
        cantidad: parseFloat((item.max - item.cantidadActual).toFixed(4)),
        tempData: {
          codigo: item.codigo,
          descripcion: item.descripcion,
          unidad: item.unidad
        }
      }));
    }

    this.setState({ controlesSeleccionados: [] });

    // Redirección con estado
    this.props.history.push("/panel/agregarRequisicion", {
      preloadedItems: itemsParaRequisicion,
      proyectoId: proyectoId
    });
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const { marcaFiltro } = this.state;
    const dataFiltrada = marcaFiltro
      ? this.state.todasControlInventario.filter(
          (item) => item.marcaId && item.marcaId.toString() === marcaFiltro.toString()
        )
      : this.state.todasControlInventario;
    const columns = [
      {
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        responsive: ["md"],
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
        width: "10%",
      },
      {
        title: "Insumo",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        defaultSortOrder: 'ascend',
        buscar: "descripcion",
        width: "35%",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        responsive: ["md"],
        sorter: (a, b) => {
          if (a.proyecto < b.proyecto) {
            return -1;
          }
          if (a.proyecto > b.proyecto) {
            return 1;
          }
          return 0;
        },
        buscar: "proyecto",
        width: "20%",
      },
      {
        title: "Marca",
        dataIndex: "marca",
        key: "marca",
        responsive: ["md"],
        sorter: (a, b) => {
          if (a.marca < b.marca) {
            return -1;
          }
          if (a.marca > b.marca) {
            return 1;
          }
          return 0;
        },
        buscar: "marca",
        width: "10%",
      },
      {
        title: "Mín.",
        dataIndex: "min",
        key: "min",
        sorter: (a, b) => {
          if (a.min < b.min) {
            return -1;
          }
          if (a.min > b.min) {
            return 1;
          }
          return 0;
        },
        width: "10%",
      },
      {
        title: "Máx.",
        dataIndex: "max",
        key: "max",
        sorter: (a, b) => {
          if (a.max < b.max) {
            return -1;
          }
          if (a.max > b.max) {
            return 1;
          }
          return 0;
        },
        width: "10%",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidadActual",
        key: "cantidadActual",
        sorter: (a, b) => {
          if (a.cantidadActual < b.cantidadActual) {
            return -1;
          }
          if (a.cantidadActual > b.cantidadActual) {
            return 1;
          }
          return 0;
        },
        width: "10%",
        render: (value, record) => (
          <span style={{ color: value <= record.min ? "#ff4d4f" : "inherit", fontWeight: value <= record.min ? 600 : "normal" }}>
            {value}
          </span>
        ),
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        responsive: ["md"],
        render: (value) => value.nombre,
        width: "10%",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: isMobile ? "13%":"10%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value,record ,index) => {
          let buttons = [];
          const m = record.max; 
          const c = record.cantidadActual;
          const habilitarGenReq= c < m; // Solo habilitar el boton si cantidad es menor que el máximo

          if(this.props.permisoAgregarRequisiciones  && this.state.proyectoId) {
            buttons.push(
            <Tooltip title="Generar requisición para completar máximo" placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto'}}>
              <ButtonItem
                  key={`gen-req-${index}`}
                  type="default"
                  size="small"
                  lila
                  disabled = {!habilitarGenReq}
                  icon={<FileAddOutlined />}
                  onClick={() => this.abrirReq(record)}
                >
                </ButtonItem>
            </Tooltip>
          )
          }

          if (this.props.permisoEditarControl) {
            buttons.push(
              <Tooltip title="Editar Control" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarControlInventario(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoEliminarControl) {
            buttons.push(
              <Popconfirm
                key={`eliminar-${index}`}
                title="Seguro que quieres eliminar este control"
                onConfirm={() => this.eliminarControlInventario(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<DeleteOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title={this.state.proyecto ? "Control Inventario: " + this.state.proyecto : "Control Inventario: Todos"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space style={{ width: "100%" }}>
              <SelectItem
                placeholder="Proyecto"
                width={200}
                onChange={this.onChangeProyecto.bind(this)}
                value={this.state.proyectoId}
                defaultValue={0}
                noFocusSiguiente
              >
                <Option value={0}>Todos</Option>
                {this.state.objetoProyectos}
              </SelectItem>
              <SelectMarcasItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Marca"
                width={200}
                value={this.state.marcaFiltro}
                onChange={(value) => this.setState({ marcaFiltro: value })}
              />
              <SelectProveedoresItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Proveedor"
                width={200}
                allowClear
                value={this.state.proveedorFiltro}
                onChange={this.onChangeProveedor.bind(this)}
              />
              <ButtonItem
                type="primary"
                key="importarControl"
                onClick={() => this.props.history.push("/panel/importarControlInventario")}
                icon={<ImportOutlined />}
                style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
              >
                Importar Controles
              </ButtonItem>
              {this.props.permisoAgregarControl &&
              <ButtonItem
                type="primary"
                key="agregarControl"
                olivo
                onClick={this.abrirAgregarControlInventario.bind(this)}
                style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
              >
                Agregar Control
              </ButtonItem>}
              
              {!!this.props.permisoAgregarRequisiciones  &&
               <Tooltip
                 title={this.state.controlesSeleccionados.length
                   ? `Genera una requisición con los ${this.state.controlesSeleccionados.length} insumo(s) seleccionados`
                   : "Selecciona insumos con las casillas, o déjalo así para generar con todo el proyecto"}
                 placement="top"
                 overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
               >
                <ButtonItem
                  type="primary"
                  key="reqMasiva"
                  lila
                  onClick={() => this.abrirReq(null)}
                  style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                >
                  {this.state.controlesSeleccionados.length
                    ? `Generar requisición (${this.state.controlesSeleccionados.length})`
                    : "Generar requisición máximos"}
                </ButtonItem>
               </Tooltip>
              }
            </Space>
          }
        />
        <TableItem
          size="small"
          dataSource={dataFiltrada}
          columns={columns}
          pagination={false}
          loading={this.state.loading}
          rowKey="_id"
          rowSelection={{
            selectedRowKeys: this.state.controlesSeleccionados,
            onChange: (keys) => this.setState({ controlesSeleccionados: keys }),
          }}
          onRow={(record) => ({
            onDoubleClick: () => this.abrirEditarControlInventario(record._id),
          })}
        //   onRow={(record, rowIndex) => {
        //     return {
        //       onDoubleClick: (event) => {
        //         this.props.history.push("/panel/inventarioInsumo", { id: record.insumo._id, proyectoId: this.state.proyectoId });
        //       },
        //     };
        //   }}
        />
        <AgregarControlInventario
          visible={this.state.modalAgregarControl}
          cerrarAgregarControlInventario={this.cerrarAgregarControlInventario.bind(
            this
          )}
        />
        <EditarControlInventario
          visible={this.state.modalEditarControl}
          id={this.state.modalEditarControlId}
          cerrarEditarControlInventario={this.cerrarEditarControlInventario.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarControl: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6750906b798d4e004368723a")?.activado,
    //permisoCancelarControl: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6750909c798d4e004368723b")?.activado,
    permisoEliminarControl: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "675090b1798d4e004368723c")?.activado,
    permisoEditarControl: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "675090c7798d4e004368723d")?.activado,
    permisoAgregarRequisiciones: 
      state.user.tipo === 0 || 
      state.user.permisos.find(
        (valueTodos) => 
          valueTodos.permisoId.toString() === "647a1971bd6a695a9801702d"
      )?.activado, 
  };
};

export default connect(mapStateToProps)(ControlInventario);
